module.exports = __webpack_public_path__ + "assets/new.7ae1ad12e4585f78d6b3d87df8368856.png";